import cx from 'classnames';
import type { AriaAttributes, FC } from 'react';

import { Icon } from '@zen/DesignSystem';

interface Props {
  isClickable: boolean;
  isCompleted: boolean;
  isCurrent: boolean;
  isFirst: boolean;
  label: string;
  onClick: () => void;
}

const WizardStepperItem: FC<Props> = (props) => {
  const { isClickable, isCompleted, isCurrent, isFirst, label, onClick } = props;

  const isActive: boolean = isCurrent || isCompleted;

  const labelClassNames: string = cx('text-sm font-medium leading-5', isCurrent ? 'text-azure-base' : 'text-grey-dark');
  const lineClassNames: string = cx(
    'absolute right-1/2 top-1/2 h-0.5 w-full -translate-y-1/2',
    isActive ? 'bg-azure-base' : 'bg-grey-lighter'
  );
  const dotClassNames: string = cx('relative z-10 flex items-center justify-center rounded-full ring-4 ring-white', {
    'h-4 w-4 border-2 border-azure-base bg-white': isCurrent,
    'h-4 w-4 bg-azure-base': isCompleted,
    'h-3 w-3 bg-grey-light': !isActive
  });
  const buttonClassNames: string = cx('flex w-full flex-col items-center space-y-2', {
    'cursor-pointer': isClickable,
    'cursor-default': !isClickable
  });
  const ariaCurrent: AriaAttributes['aria-current'] = isCurrent ? 'step' : undefined;

  return (
    <li className="relative flex-1" data-component="wizard-stepper-item">
      <button aria-current={ariaCurrent} className={buttonClassNames} disabled={!isClickable} onClick={onClick} type="button">
        <span className={labelClassNames}>{label}</span>
        <span className="relative flex h-4 w-full items-center justify-center">
          {!isFirst && <span aria-hidden="true" className={lineClassNames} />}
          <span className={dotClassNames}>
            {isCurrent && <span className="h-1.5 w-1.5 rounded-full bg-azure-base" />}
            {isCompleted && <Icon className="text-[8px] text-white" icon="zicon-tick" />}
          </span>
        </span>
      </button>
    </li>
  );
};

export type { Props as WizardStepperItemProps };
export default WizardStepperItem;
